import { Swiper } from '@services';
import { M as Mousewheel } from './mousewheel-C5j9rBbp.js';
import './utils-BgX2tuHA.js';

class CollectionNavigation extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.swiper, {
      modules: [Mousewheel],
      slidesPerView: 'auto',
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('collection-navigation', CollectionNavigation);
